module.exports = {"341204001":"中市街道","341204002":"周棚街道","341204100":"伍明镇","341204101":"宁老庄镇","341204102":"闻集镇","341204103":"行流镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341204.json
// module id = 1122
// module chunks = 0